import React from 'react';
import {NumericFormat} from 'react-number-format';
import {TextField, TextFieldProps} from '@mui/material';

const AmountTextField = ({name, label, value, onChange, ...other}: TextFieldProps) => {

  const {inputProps, defaultValue, type, ...theRest} = other;

  return (
    <NumericFormat
      {...theRest}
      fullWidth={other.fullWidth}
      label={label}
      onValueChange={values => {
        if (onChange) {
          onChange({
            target: {
              name: name ?? '',
              value: '' + values.value
            }
          } as React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>);
        }
      }}
      name={name || label as string}
      value={value as number}
      customInput={TextField}

      decimalScale={2}
      allowNegative={false}
      thousandSeparator={inputProps?.thousandSeparator ? ' ' : false}
      valueIsNumericString
      suffix={inputProps?.suffix}
    />
  );
};

export default AmountTextField;
